import React from "react";
import PropTypes from "prop-types";
import Flatpickr from "react-flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt";

const defaultProps = {
  className: "",
  defaultValue: "",
  placeholder: "",
  required: false,
};

function DateRangeInput(props) {
  function handleDateRangeChange(_, dateStr, instance) {
    instance.element.value = dateStr.replace("até", "-");
  }

  return (
    <div className="relative">
      <Flatpickr
        className={`form-input cursor-pointer ${props.className}`}
        id={props.name}
        name={props.name}
        options={{
          defaultDate: props.defaultValue,
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: "d/m/Y",
          locale: Portuguese,
          mode: "range",
        }}
        placeholder={props.placeholder}
        required={props.required}
        onReady={handleDateRangeChange}
        onChange={handleDateRangeChange}
      />

      <div className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 pointer-events-none">
        <svg viewBox="0 0 24 24" fill="none" className="text-slate-400 w-5 h-5">
          <path fill="currentColor"
                d="M16.75 3.995a.75.75 0 0 0-1.5.01zm-1.49 1.51a.75.75 0 0 0 1.5-.01zm-6.51-1.51a.75.75 0 0 0-1.5.01zm-1.49 1.51a.75.75 0 0 0 1.5-.01zM8 12.25a.75.75 0 0 0 0 1.5zm.01 1.5a.75.75 0 0 0 0-1.5zM8 15.25a.75.75 0 0 0 0 1.5zm.01 1.5a.75.75 0 0 0 0-1.5zm3.99-4.5a.75.75 0 0 0 0 1.5zm.01 1.5a.75.75 0 0 0 0-1.5zm-.01 1.5a.75.75 0 0 0 0 1.5zm.01 1.5a.75.75 0 0 0 0-1.5zm3.99-4.5a.75.75 0 0 0 0 1.5zm.01 1.5a.75.75 0 0 0 0-1.5zm-.01 1.5a.75.75 0 0 0 0 1.5zm.01 1.5a.75.75 0 0 0 0-1.5zM4.964 19.591l-.476.58zm-.554-.555-.58.476zm15.184.003.58.476zm-.555.554.476.58zm.007-13.184-.476.58zm.554.555-.58.475zm-8.595-.714h2v-1.5h-2zm2 13.5h-2v1.5h2zm-9.505-9h17v-1.5h-17zm11.75-6.745.01 1.5 1.5-.01-.01-1.5zm-8 0 .01 1.5 1.5-.01-.01-1.5zM8 13.75h.01v-1.5H8zm0 3h.01v-1.5H8zm4-3h.01v-1.5H12zm0 3h.01v-1.5H12zm4-3h.01v-1.5H16zm0 3h.01v-1.5H16zm-4.995 3c-1.663 0-2.844-.001-3.75-.108-.89-.106-1.417-.304-1.815-.63l-.952 1.159c.71.582 1.558.838 2.59.96 1.015.12 2.3.119 3.927.119zm-8.25-6.755c-.001 1.626-.003 2.912.116 3.927.121 1.031.377 1.88.959 2.59l1.16-.951c-.327-.398-.524-.925-.63-1.814-.106-.907-.106-2.088-.105-3.751zm2.685 6.017a3.252 3.252 0 0 1-.45-.451l-1.16.951c.197.24.418.461.658.659zm14.315-6.007c-.001 1.66-.003 2.84-.11 3.746-.106.889-.305 1.415-.63 1.812l1.158.952c.582-.709.838-1.557.96-2.587.121-1.014.12-2.298.122-3.923zm-6.75 8.245c1.624 0 2.909.001 3.922-.119 1.03-.121 1.88-.377 2.588-.958l-.951-1.16c-.398.326-.924.524-1.813.629-.905.107-2.085.108-3.746.108zm6.01-2.687a3.254 3.254 0 0 1-.451.45l.951 1.16c.24-.198.46-.418.658-.658zM13.004 6.25c1.663 0 2.845.001 3.75.108.89.106 1.417.304 1.815.63l.952-1.159c-.71-.582-1.558-.838-2.59-.96-1.015-.12-2.3-.119-3.927-.119zm8.25 6.756c.001-1.627.003-2.913-.116-3.928-.121-1.031-.377-1.88-.959-2.59l-1.16.951c.326.398.524.925.63 1.815.106.906.106 2.087.105 3.75zM18.57 6.988c.164.135.315.286.45.451l1.16-.951a4.755 4.755 0 0 0-.658-.659zM11.005 4.75c-1.624 0-2.909-.001-3.922.119-1.03.121-1.88.377-2.588.958l.951 1.16c.398-.326.924-.524 1.813-.629.905-.107 2.085-.108 3.746-.108zm-6.75 8.246c.001-1.662.003-2.841.11-3.747.106-.889.305-1.415.63-1.812l-1.158-.952c-.582.709-.838 1.557-.96 2.587-.121 1.014-.12 2.298-.122 3.923zm.24-7.169a4.75 4.75 0 0 0-.658.658l1.159.952a3.25 3.25 0 0 1 .45-.45z"/>
        </svg>
      </div>
    </div>
  );
}

DateRangeInput.defaultProps = defaultProps;
DateRangeInput.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.array,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

export default DateRangeInput;
